import { Link } from '@/components/Elements/Link';
import { useSetFilterConditionAtom } from '@/features/analyze/atoms/filterCondition.atom';
import { buildAnalyzeSearchUrl } from '@/features/analyze/lib/buildAnalyzeSearchUrl';
import { FilterCondition } from '@/features/analyze/types';
import { ComponentProps } from 'react';

const createThemeFilterCondition = (
  themeTableName?: string
): FilterCondition =>
  themeTableName ? { themes: { and: [themeTableName] } } : {};

type ThemeSearchLinkProps = Omit<
  ComponentProps<typeof Link>,
  'to' | 'onClick'
> & {
  themeTableName?: string;
};

export const ThemeSearchLink = ({
  themeTableName,
  ...props
}: ThemeSearchLinkProps) => {
  const setFilterCondition = useSetFilterConditionAtom();
  const themeFilterCondition = createThemeFilterCondition(themeTableName);

  const handleClick = () => {
    // TODO: 中期対応
    // setHash: () => {} は「空の hash を設定」ではなく、atomWithHash の hash 更新を無効化する no-op。
    // 目的は /themes に #q=... を残さないこと（戻る操作で hash 付き /themes に戻るのを防ぐため）。
    // 遷移先URLの反映は Link の to (buildAnalyzeSearchUrl) が担う。
    // filterCondition を query parameter (?q=...) 同期へ移行したら、この暫定対応は見直す。
    setFilterCondition(themeFilterCondition, {
      setHash: () => {},
    });
  };

  return (
    <Link
      to={buildAnalyzeSearchUrl(themeFilterCondition)}
      onClick={handleClick}
      {...props}
    />
  );
};
